import api from '../../api/projects'
import { GET_FILES } from "../types"

export const getFiles = () => async dispatch => {
  const results = await api.get('/files')
  dispatch({ type: GET_FILES, payload: results.data })
}
